<template>
    <div
        class="field-wrapper"
        @click="$refs.textarea.focus()"
        :class="{ hasValue: value, hasErrors: errors.length, dark }"
    >
        <textarea
            v-bind="$attrs"
            ref="textarea"
            v-model="value"
            @focus="errors = []"
            v-on:input="$emit('input', $event.target.value)"
        ></textarea>
        <div class="field-placeholder">
            <span>{{ placeholder }}</span>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        placeholder: {
            type: String,
            required: true,
        },
        initialValue: {
            required: false,
            default: ""
        },
        initialErrors: {
            type: Array,
            required: false,
            default: () => [],
        },
        dark:{
            type: Boolean,
        }
    },

    data() {
        return {
            value: this.initialValue,
            errors: this.initialErrors
        };
    },

    mounted () {
        this.$el.closest('form').addEventListener('reset', () => {
            this.value = '';
        });
    },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.dark{
    &:hover {
        border: 2px solid white!important;
        border-radius: 4px;
    }
    textarea {
        border: 2px solid rgba(255, 255, 255, 0.6);
        background-color: transparent!important;
        color: white!important;
    }
    textarea:focus {
        border: 2px solid white!important;
    }

    .field-placeholder {
        color: rgba(255, 255, 255, 0.6);

        span {
            background: $plum;
            color: inherit;
        }
    }

    textarea:not([disabled]):focus~.field-placeholder {
        color: rgba(255, 255, 255, 1);
    }
}
.field-wrapper {
    position: relative;
    height: 10rem;
    cursor: text;
    border: none;

    &:hover {
        border-radius: 4px;
    }
}

.field-wrapper textarea {
    padding: 15px;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    background-color: transparent;
    color: white;
    outline: none;
    border: 2px solid rgba(255, 255, 255, 0.6);

    &:focus {
        border: 2px solid rgba(255, 255, 255, 1);
    }
}

.field-wrapper .field-placeholder {
    font-size: 16px;
    position: absolute;
    top: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: $plum;
    left: 8px;
    padding: 0 8px;
    -webkit-transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
    text-align: left;
    width: 100%;
}

.field-wrapper .field-placeholder span {
    background: $plum;
    padding: 0px 8px;
    color: rgba(255, 255, 255, 0.6);
    font-weight: normal;
}

.field-wrapper textarea:not([disabled]):focus ~ .field-placeholder {
    color: white;
    span {
        color: white;
    }
}

.field-wrapper textarea:not([disabled]):focus ~ .field-placeholder,
.field-wrapper.hasValue textarea:not([disabled]) ~ .field-placeholder {
    -webkit-transform: scale(0.75) translateY(-29px) translateX(-16%);
    transform: scale(0.75) translateY(-29px) translateX(-16%);
}
</style>
